import { Route, Switch } from 'react-router-dom';
import loadable from '@loadable/component';

// Pages
import NotFoundPage from 'app/shared/pages/NotFoundPage';
import UserPage from 'app/shared/pages/UserPage';
import UnsubscribePage from 'app/shared/pages/UnsubscribePage';
// @ts-ignore
import WebSocketPage from 'app/shared/pages/WebSocketPage';

// Components
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

// SSR
import FrontPageSrwm from 'app/shared/pages/FrontPage/ssr';
import MarketTrendsPageSrwm from 'app/shared/pages/MarketTrendsPage/ssr';
import MarketTrendsResultsPageSrwm from 'app/shared/pages/MarketTrendsResultsPage/ssr';
import PriceMyRentalResultsPageSrwm from 'app/shared/pages/PriceMyRentalResultsPage/ssr';
import UnsubscribeAllPageSrwm from 'app/shared/pages/UnsubscribeAllPage/ssr';
import UnsubscribePageSrwm from 'app/shared/pages/UnsubscribePage/ssr';

// Actions / Utils
import pathsManifest from 'app/shared/utils/pathsManifest';
import UnsubscribeAllPage from 'app/shared/pages/UnsubscribeAllPage';

const FrontPage = loadable(() => import(/* webpackChunkName: "FrontPage.loadable" */ 'app/shared/pages/FrontPage'), {
  fallback: <SpinnerContainer />,
});

const PriceMyRentalResultsPage = loadable(
  () => import(/* webpackChunkName: "PriceMyRentalResultsPage.loadable" */ 'app/shared/pages/PriceMyRentalResultsPage'),
  {
    fallback: <SpinnerContainer />,
  },
);

const MarketTrendsResultsPage = loadable(
  () => import(/* webpackChunkName: "MarketTrendsResultsPage.loadable" */ 'app/shared/pages/MarketTrendsResultsPage'),
  {
    fallback: <SpinnerContainer />,
  },
);

const MarketTrendsPage = loadable(
  () => import(/* webpackChunkName: "MarketTrendsPage.loadable" */ 'app/shared/pages/MarketTrendsPage'),
  {
    fallback: <SpinnerContainer />,
  },
);

const ZRMLoginPage = loadable(
  () => import(/* webpackChunkName: "ZRMLoginPage.loadable" */ 'app/shared/pages/ZRMLogin'),
  {
    fallback: <SpinnerContainer />,
  },
);

// ORDER MATTERS: PUT MORES SPECIFIC ROUTES BEFORE LESS SPECIFIC
// look at PriceMyRental pages
export default function getRoutes() {
  return (
    <Switch>
      <Route
        exact
        component={FrontPage}
        path="/"
        // @ts-ignore
        serverRouteWillMount={FrontPageSrwm}
      />
      <Route
        component={PriceMyRentalResultsPage}
        path={`${pathsManifest.PriceMyRentalPageResults}/:address`}
        // @ts-ignore
        serverRouteWillMount={PriceMyRentalResultsPageSrwm}
      />
      <Route
        component={MarketTrendsResultsPage}
        path={`${pathsManifest.MarketTrendsPage}/:area`}
        // @ts-ignore
        serverRouteWillMount={MarketTrendsResultsPageSrwm}
      />
      <Route
        component={MarketTrendsPage}
        path={`${pathsManifest.MarketTrendsPage}`}
        // @ts-ignore
        serverRouteWillMount={MarketTrendsPageSrwm}
      />

      {/*
        pageWithSensitiveInformation flag is passed to api to require authentication
        e.g. password typed in recently
      */}
      <Route
        component={UserPage}
        // @ts-ignore
        pageWithSensitiveInformation
        path="/user"
      />
      <Route
        component={UnsubscribeAllPage}
        path={pathsManifest.UnsubscribeAllPage}
        // @ts-ignore
        serverRouteWillMount={UnsubscribeAllPageSrwm}
      />
      <Route
        component={UnsubscribePage}
        path={pathsManifest.UnsubscribePage}
        // @ts-ignore
        serverRouteWillMount={UnsubscribePageSrwm}
      />

      <Route component={WebSocketPage} path={pathsManifest.WebSocketPage} />
      <Route component={ZRMLoginPage} path={pathsManifest.ZRMLoginPage} />
      <Route component={NotFoundPage} path="*" />
    </Switch>
  );
}
